import React from "react";
import Layout from "../../utils/Layout";
const Hospitallist = () => {
  return <Layout>Hospitallist Hospitallist</Layout>;
};

export default Hospitallist;
